import { render, staticRenderFns } from "./ManageTribunal.vue?vue&type=template&id=3b8ebafc&scoped=true"
import script from "./ManageTribunal.vue?vue&type=script&lang=js"
export * from "./ManageTribunal.vue?vue&type=script&lang=js"
import style0 from "./ManageTribunal.vue?vue&type=style&index=0&id=3b8ebafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ebafc",
  null
  
)

export default component.exports